import React from "react";
import { HeartHandshake, ShieldCheck, Sparkles } from "lucide-react";

const pillars = [
  {
    icon: HeartHandshake,
    title: "Ängste nehmen",
    text: "Notfälle sind beängstigend. Paula macht sie greifbar — und damit kleiner.",
    color: "bg-paula-red-soft",
    iconColor: "text-paula-red",
  },
  {
    icon: ShieldCheck,
    title: "Wissen schenken",
    text: "Kinder lernen, wann sie 112 wählen, wie sie helfen, und dass jeder etwas tun kann.",
    color: "bg-paula-blue-soft",
    iconColor: "text-paula-blue",
  },
  {
    icon: Sparkles,
    title: "Mut machen",
    text: "Wer einmal Held sein durfte, bleibt es. Paula gibt Kindern dieses Gefühl.",
    color: "bg-paula-yellow-soft",
    iconColor: "text-paula-yellow",
  },
];

export const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-red mb-4">
            Unsere Mission
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-paula-ink leading-[1.05] tracking-tight">
            Kinder in Erster Hilfe stärken —{" "}
            <span className="text-paula-muted">
              Ängste nehmen, Mut schenken.
            </span>
          </h2>
          <p className="mt-7 text-lg text-paula-muted leading-relaxed max-w-2xl">
            Jedes Kind kann helfen. Nicht erst irgendwann — sondern heute, im
            Kindergarten, in der Schule, am Spielplatz. Paula zeigt wie. Mit
            einer Geschichte, die berührt, und Bildern, die bleiben.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {pillars.map((p) => (
            <div
              key={p.title}
              data-testid={`mission-pillar-${p.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="group relative p-8 rounded-3xl bg-white border border-slate-200 hover:border-paula-ink transition-colors"
            >
              <div
                className={`w-14 h-14 rounded-2xl ${p.color} grid place-items-center mb-6`}
              >
                <p.icon className={p.iconColor} size={26} />
              </div>
              <h3 className="font-display font-semibold text-2xl text-paula-ink mb-3">
                {p.title}
              </h3>
              <p className="text-paula-muted leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Mission;
